<template>
  <div class="page-header-wrapper">
    <h1>{{ $t("bnpl:b2b.kyc.waiting.title") }}</h1>
    <p>{{ $t("bnpl:b2b.kyc.waiting.subtitle") }}</p>
  </div>
  <div class="whitebox flex-column align-items-center p-3">
    <div class="spinner-container">
      <IllustrationsSpinnerCircle />
    </div>
    <h3 class="has-text-grey text-center bold m-0 mb-3">
      {{ $t("bnpl:b2b.kyc.waiting.spinner.title") }}
    </h3>
    <div
      class="flex-row"
      style="
        gap: 16px;
      "
    >
      <button
        v-if="showRestart"
        class="btn btnL btn-link btn-primary"
        :disabled="restartPending"
        @click="restartKyc"
      >
        {{ $t("b2b:kyc.restart") }}
      </button>
      <button
        v-if="isMobile"
        class="btn btnL"
        @click="resumeKyc"
      >
        {{ $t("b2b:kyc.resume") }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useKycStore } from '~~/stores/kyc';
import platform from 'platform';

const kycStore = useKycStore();
const route = useRoute();
const showRestart = ref(false);
const restartPending = ref(false);
const url = computed(() => kycStore.url);

const isMobile = computed(() => {
  if (['Android', 'iOS', 'Windows Phone'].includes(platform.os.family)) {
    return true;
  }
  return false;
});

function restartKyc() {
  kycStore.restartKyc(route.params.publicId);
}

function resumeKyc() {
  window.location.assign(kycStore.url);
}

let showRestartTimeout = null;

onMounted(() => {
  showRestartTimeout = setTimeout(() => {
    showRestart.value = true;
  }, 10000);
});

onBeforeUnmount(() => {
  clearTimeout(showRestartTimeout);
});
</script>

<style lang="scss" scoped>
.spinner-container {
  align-self: center;
  padding: 50px;
}

.has-text-grey {
  color: var(--gray400);
}
</style>